// extracted by mini-css-extract-plugin
export var circleTimerContent = "CustomCountdown-module--circleTimerContent--8da8b";
export var countdownContainer = "CustomCountdown-module--countdownContainer--3a622";
export var lmsScrollbar = "CustomCountdown-module--lms-scrollbar--7b62c";